// src/hooks/useLeadForm.js

let openFormCallback = null;

export const useLeadForm = () => {
  const showLeadForm = (state, type, callback) => {
    openFormCallback?.(state, type, callback);
  };

  const registerFormTrigger = (fn) => {
    openFormCallback = fn;
  };

  return { showLeadForm, registerFormTrigger };
};
